<template lang="html">
  <ol class="nav-buttons">
    <slot>
      <li class="nav-button-item">
        <router-link :to="{ name: 'settings' }">
          <b v-if="currentUser">{{ currentUser.email }}</b>
          <template v-else>Settings</template>
        </router-link>
      </li>
      <li class="nav-button-item">
        <router-link :to="{ name: 'about' }">About</router-link>
      </li>
      <li class="nav-button-item">
        <a
          href="https://mhluska.github.io/blackjack-atlas/simulations/"
          target="_blank"
        >
          Simulator
        </a>
      </li>
      <template v-if="currentUser">
        <li class="nav-button-item">
          <a class="logout-button" role="button" @click="handleLogout">
            Logout
          </a>
        </li>
      </template>
      <template v-else>
        <li class="nav-button-item">
          <router-link :to="{ name: 'login' }">Login</router-link>
        </li>
        <li class="nav-button-item">
          <router-link :to="{ name: 'join' }">Signup</router-link>
        </li>
      </template>
    </slot>
  </ol>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'NavButtons',

  computed: {
    ...mapGetters(['currentUser']),
  },

  methods: {
    handleLogout(options) {
      this.$store.dispatch('setCurrentUserId', null);

      const logoutOptions = {
        makeRequest: true,
        ...options,
      };

      return this.$auth.logout(logoutOptions);
    },
  },
};
</script>

<style scoped lang="scss">
@import '@/styles/mixins/unstyled-list';

$spacing-horizontal: 1em;

.nav-buttons {
  @include unstyled-list;

  flex-direction: column;
  margin: 0 -$spacing-horizontal;

  &.in-popover {
    padding: 0.5em 0;
    margin: 0;
  }
}

.nav-button-item {
  font-weight: map-get($font-weights, 'bold-1x');

  a {
    color: inherit;
    display: block;
    text-decoration: none;
    padding: 0.5em $spacing-horizontal;
  }
}

@media all and (min-width: map-get($breakpoints, 'phone')) {
  .nav-buttons {
    flex-direction: row;
  }

  .nav-button-item a {
    padding: 0.5em;
  }
}
</style>
